import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Account from './views/Account.vue'
import Logoff from './views/Logoff.vue'
import Documents from './views/Documents.vue'
import Conditions from './views/Conditions.vue'
import OnlineBanking from './views/OnlineBanking.vue'
import Store from './store/index'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    return {
      x: 0,
      y: 0
    }
  },
  base: process.env.BASE_URL,
  routes: [{
      path: '/',
      name: 'signin',
      component: Home
    },
    {
      path: '/signup',
      name: 'signup',
      component: Home
    },
    {
      path: '/resetpassword',
      name: 'resetpassword',
      component: Home
    },
    {
      path: '/online-banking',
      name: 'onlinebanking',
      component: OnlineBanking
    },
    {
      path: '/myaccount',
      name: 'account',
      component: Account,
      beforeEnter: requireAuth
    },
    {
      path: '/mydocuments',
      name: 'documents',
      component: Documents,
      beforeEnter: requireAuth
    },
    {
      path: '/logoff',
      name: 'logoff',
      component: Logoff
    },
    {
      path: '/terms-conditions',
      name: 'conditions',
      component: Conditions
    }
  ]
})

router.beforeEach((to, from, next) => {
  let sub = window.location.host.split(".")[0]
  if (sub.includes("retirement")) {
    Store.commit("user/setRetirementBranded", true)
  } else if (sub.includes("mers")) {
    Store.commit("user/setMERSBranded", true)
  }
  next()
})

async function requireAuth(to, from, next) {
  if (Store.getters["user/isAuthenticated"]) {
    next()
  }
  else {
    if (await Store.dispatch("user/checkUser")) {
      next()
    }
    else {
      next("/")
    }
  }
}

export default router